import { render, staticRenderFns } from "./CreateItemModel.vue?vue&type=template&id=c947ca94"
import script from "./CreateItemModel.vue?vue&type=script&lang=js"
export * from "./CreateItemModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports